import React from 'react'
import { Button } from 'reactstrap'
import { CircularProgress } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

function CopyButton(props) {
  const { onClick, loading, title } = props
  return (
    <div className='actions-right'>
      <Button color='success' size='sm' disabled={loading} onClick={onClick} title='Kopioi'>
        {loading ? <CircularProgress size={10} color={'inherit'} /> : <ContentCopyIcon fontSize={'inherit'} />}
        {title ? title : null}
      </Button>
    </div>
  )
}

export default CopyButton
